module.exports = __webpack_public_path__ + "img/Moshe.735132ef.jpg";